import { Query } from '@/_core/cqrs/types/queries';

export class SubdomainIsValidQuery extends Query<boolean> {
    constructor(public Subdomain: string) {
        super('SubdomainIsValidQuery');
    }
}
